import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useInView, reveal } from './motion';

// Shared editorial heading: eyebrow overline + display title + optional lede.
// `align` controls text alignment; `accent` tints the eyebrow.
export default function SectionHeading({ eyebrow, title, lede, align = 'left', accent, maxWidth = 720, sx }) {
  const theme = useTheme();
  const { ref, visible } = useInView();
  const accentColor = accent || theme.home.cyanText;

  return (
    <Box ref={ref} sx={{ textAlign: align, mx: align === 'center' ? 'auto' : 0, maxWidth, ...sx }}>
      {eyebrow && (
        <Typography
          variant="overline"
          sx={{
            display: 'inline-flex', alignItems: 'center', gap: 1, color: accentColor,
            mb: 1.5, ...reveal(visible),
          }}
        >
          <Box component="span" sx={{ width: 26, height: 2, bgcolor: accentColor, display: 'inline-block' }} />
          {eyebrow}
        </Typography>
      )}
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: '2rem', md: '2.85rem' }, color: theme.home.ink,
          ...reveal(visible, 0.06),
        }}
      >
        {title}
      </Typography>
      {lede && (
        <Typography
          sx={{
            mt: 2, color: theme.home.inkMuted, fontSize: { xs: '1.05rem', md: '1.2rem' },
            lineHeight: 1.6, maxWidth: 620, mx: align === 'center' ? 'auto' : 0,
            ...reveal(visible, 0.12),
          }}
        >
          {lede}
        </Typography>
      )}
    </Box>
  );
}
